import { Chip } from '@nexvia-logistics/ui';
import { Clock, Info, Minus } from '@nexvia-logistics/ui/icons';
import { QUOTE_STATUS_LABELS, type StorageQuote } from '@/shared/storage-api';
import { CheckIcon } from '@/shared/icons';

/**
 * One real `Chip` per `QuoteStatus` — NEX-1165 design pass (spec 2026-10-18 §3.3), the mock's chips:
 * "Esperando respuesta" info with a clock, "Aceptada" the solid active pill with a check, "No
 * seleccionada" quiet neutral with a dash (the client picked another depósito: no alarm), "Vencida"
 * neutral with an info mark; `cancelled` (no mock) the plain neutral one. Shared by Mis cotizaciones'
 * rows and the quote's own page.
 */
export function QuoteStatusChip({ quote }: { quote: StorageQuote }) {
  const label = QUOTE_STATUS_LABELS[quote.status] ?? quote.status;
  switch (quote.status) {
    case 'accepted':
      return (
        <Chip tone="active" icon={<CheckIcon size={12} />}>
          {label}
        </Chip>
      );
    case 'pending':
      return (
        <Chip tone="info" icon={<Clock size={12} />}>
          {label}
        </Chip>
      );
    case 'rejected':
      return (
        <Chip tone="neutral" icon={<Minus size={12} />}>
          {label}
        </Chip>
      );
    case 'expired':
      return (
        <Chip tone="neutral" icon={<Info size={12} />}>
          {label}
        </Chip>
      );
    default:
      return <Chip tone="neutral">{label}</Chip>;
  }
}
